/**
 * O'zbekcha lug'at — MANBA TIL.
 *
 * Bu fayl kalitlarni ham BELGILAYDI: `Dict` tipi shundan olinadi, ya'ni
 * boshqa tilda kalit yetishmasa yoki ortiqcha bo'lsa TypeScript aytadi.
 * Ish vaqtida "kalit topilmadi" holatiga tushib qolmaymiz.
 *
 * KO'PLIK SHAKLLARI `#` bilan ajratiladi:
 *
 *     "days.left#one"   -> "1 kun qoldi"
 *     "days.left#other" -> "{n} kun qoldi"
 *
 * O'zbekchada ikkita shakl bor (one/other), rus tilida TO'RTTA
 * (one/few/many/other). Qaysi shakl kerakligini `Intl.PluralRules`
 * hal qiladi — qo'lda yozilgan qoidalar rus tilida deyarli har doim
 * 21 va 101 da xato qiladi (ular `one`, `many` emas).
 *
 * Kalit nomlash: `<ekran>.<element>`. Umumiy narsalar `common.` da.
 */

export const uz = {
  // --- umumiy ---
  "common.loading": "Yuklanmoqda…",
  "common.error": "Xatolik yuz berdi",
  "common.retry": "Qayta urinish",
  "common.back": "Orqaga",
  "common.close": "Yopish",
  "common.notFound": "Topilmadi",
  "common.unknown": "aniqlanmadi",
  "common.all": "Hammasi",
  "common.more": "Batafsil",
  // Ikkitadan ortiq ekranda ishlatiladi — shuning uchun `common.`
  "common.loadFailed": "Yuklab bo'lmadi",

  // --- sana va muddat ---
  "date.unknown": "aniqlanmadi",
  "days.past": "muddat o'tgan",
  "days.today": "bugun tugaydi",
  "days.left#one": "{n} kun qoldi",
  "days.left#other": "{n} kun qoldi",
  "months.left#one": "~{n} oy qoldi",
  "months.left#other": "~{n} oy qoldi",

  // --- lenta ---
  "feed.empty": "Hozircha imkoniyat yo'q",
  "feed.emptyHint": "Filtrlarni kengaytirib ko'ring",
  "feed.results#one": "{n} ta natija",
  "feed.results#other": "{n} ta natija",
  // Ro'yxat sahifalab keladi (qidiruv 30 tadan, saqlanganlar 20 tadan).
  // Bu tugmasiz `total` da sanalgan, lekin birinchi sahifaga sig'magan
  // e'lonlarga umuman yetib bo'lmasdi.
  "feed.loadMore": "Yana ko'rsatish",

  // --- e'lon sahifasi ---
  "detail.apply": "Ariza berish",
  "detail.save": "Saqlash",
  "detail.saved": "Saqlandi",
  "detail.remind": "Eslatma",
  "detail.share": "Ulashish",
  "detail.who": "Kimlar ariza bera oladi",
  "detail.benefits": "Nima beriladi",
  "detail.documents": "Kerakli hujjatlar",
  "detail.source": "Manba",
  "detail.deadline": "Muddat",
  "detail.noRestriction": "Fuqarolik cheklovi topilmadi — manbadan tekshiring",
  "detail.evidence": "Manbada: «{text}»",
  "detail.stories": "G'oliblar hikoyasi",
  "detail.verified": "Tasdiqlangan",
  "detail.userStory": "Foydalanuvchi hikoyasi",

  // --- bosh ekran ---
  "home.forYou": "Siz uchun",
  "home.quickFilters": "Tez filtrlar",
  "home.categories": "Toifalar",
  "home.allCategories": "Barcha toifalar",
  "home.deadlineSoon": "Deadline yaqin",
  "home.hide": "Yashirish",
  "home.empty": "Hozircha mos imkoniyat yo'q",
  "home.emptyHint": "Yangi e'lonlar har kuni qo'shiladi.",

  // --- saqlanganlar ---
  "saved.empty": "Saqlangan imkoniyat yo'q",
  "saved.emptyHint": "Grant sahifasida «Saqlash» tugmasini bosing — "
    + "deadline yaqinlashganda eslatma yuboramiz.",

  // --- qidiruv ---
  "search.placeholder": "Grant, tashkilot yoki kalit so'z",
  "search.empty": "Hech narsa topilmadi",
  "search.emptyHint": "Filtrlarni kamaytirib ko'ring — barcha toifalar mavjud.",
  "search.failed": "Qidiruv ishlamadi",
  // Ro'yxat oxiridagi tugma — har bosishda yana 10 ta grant
  "search.loadMore": "Ko'rishni davom ettirish",
  "search.shownOf": "{total} tadan {shown} tasi ko'rsatildi",
  "search.loadMoreFailed": "Yuklab bo'lmadi. Qayta bosib ko'ring.",
  "search.sortMatch": "Mos kelishi",
  "search.sortNew": "Yangi",
  "search.sortDeadline": "Deadline",
  "search.filterType": "Toifa",
  "search.filterLevel": "Daraja",
  "search.filterFunding": "Moliya",
  "search.filterField": "Soha",
  "search.filterContinent": "Qit'a",

  // --- onboarding ---
  "onboarding.skip": "O'tkazib yuborish",
  "onboarding.saving": "Saqlanmoqda…",
  "onboarding.saveFailed": "Saqlab bo'lmadi. Qayta urinib ko'ring.",

  // --- e'lon sahifasi (davomi) ---
  "detail.summary": "Qisqacha",
  "detail.covered": "Nima qoplanadi",
  "detail.level": "Daraja",
  "detail.funding": "Moliya",
  "detail.format": "Format",
  "detail.location": "Joylashuvi",
  // TIL TALABI (IELTS va h.k.), interfeys tili EMAS —
  // nomlar chalkashmasin
  "detail.languageReq": "Til",
  "detail.fee": "Ariza to'lovi",
  "detail.feeFree": "Bepul",
  "detail.feeUnknown": "Bor (summasi aniqlanmagan)",
  "detail.similar": "O'xshash imkoniyatlar",
  "detail.winners": "G'oliblar tajribasi",
  "detail.proofVerified": "Hujjat bilan tasdiqlangan",
  "detail.sourceLink": "Manbaga o'tish",
  "detail.savedState": "Saqlangan",
  "detail.savedNoRemind": "Saqlangan (Eslatma o'chirilgan)",
  "detail.unsave": "Saqlanganni o'chirish",
  "detail.like": "Yoqdi",
  "detail.unlike": "Yoqdi belgisini olib tashlash",
  "detail.saveHint": "Bosib saqlang: deadline yaqinlashganda eslatma yuboramiz",
  "detail.remindOn":
    "Eslatma faol: deadline tugashiga 7, 3 va 1 kun qolganda bot xabar yuboradi",
  "detail.shareHint": "Telegram orqali do'stlarga yoki guruhga yuborish",
  "detail.shareUnset": "Ulashish havolasi sozlanmagan.",
  "detail.actionFailed": "Amalni bajarib bo'lmadi.",
  // Bu ikkitasi ATAYLAB to'liq jumla, bo'lakma-bo'lak emas: tarjimon
  // bo'lakni ko'rsa, jumla qanday tugashini bilmaydi va so'z tartibi
  // boshqa tilda buziladi.
  "detail.remindLimitSaved":
    "E'lon saqlandi, lekin eslatma yoqilmadi: eslatmalar soni chegarasiga "
    + "yetdingiz. «Saqlanganlar» bo'limidan eskilaridan birini o'chiring.",
  "detail.remindLimitShort":
    "Saqlandi, lekin eslatmalar soni chegarasiga yetdingiz. "
    + "Eski eslatmalardan birini o'chiring.",

  // --- til ---
  // Zaxira belgisi: so'ralgan tilda matn yo'q. Buni JIMGINA qoldirib
  // bo'lmaydi — bir sahifada bitta til va u qaysi til ekani aytiladi.
  "lang.fallback": "Asl matn, {lang} tilida",
  "lang.switchOffer": "Bu e'lon {lang} tilida ham bor",
  "lang.switch": "O'tish",
  "lang.keep": "Qolsin",
  "lang.title": "Til",

  // --- pastki navigatsiya ---
  "nav.home": "Bosh",
  "nav.search": "Qidiruv",
  "nav.saved": "Saqlangan",

  // --- mavzu (bosh ekrandagi tugma) ---
  "theme.title": "Mavzu",
  "theme.auto": "Telegram kabi",
  "theme.light": "Kunduzgi",
  "theme.dark": "Tungi",

  // --- ilova darajasidagi xatolar ---
  "app.startFailed": "Ishga tushmadi",
  "error.title": "Nimadir noto'g'ri ketdi",
  "error.hint": "Bu sahifani ko'rsatib bo'lmadi. Qayta urinib ko'ring — "
    + "muammo takrorlansa, keyinroq kirib ko'ring.",
  "error.reload": "Qayta yuklash",

  // --- umumiy komponentlar ---
  "card.deadlineUnknown": "Muddat aniqlanmadi",
  "card.openMap": "Xaritada ochish",

  // REKLAMA YORLIG'I — QONUNIY TALAB, bezak emas. O'zbekiston
  // «Reklama to'g'risida»gi qonuni reklamani ajratib ko'rsatishni
  // talab qiladi, ya'ni bu matn HAR BIR tilda bo'lishi shart va uni
  // zaxiraga qoldirib bo'lmaydi.
  "ribbon.ad": "Reklama",
  // Ekran o'quvchisi uchun — ko'z bilan ko'rinmaydi, lekin bu ham
  // foydalanuvchi matni va tarjimasiz qolsa e'tiborsiz o'tib ketardi.
  "ribbon.label": "E'lonlar lentasi",

  // --- e'lon sahifasi (qolgani) ---
  "detail.applyDeadline": "Ariza muddati",
  "detail.closedNotice": "Bu imkoniyat yopilgan. Ariza qabul qilinmaydi.",
  "detail.enrollmentRequired": "Talaba bo'lish shart",
  // BUTUN JUMLA, bo'lakma-bo'lak emas (yuqoridagi `remindLimit` izohiga
  // qarang): «Yosh: 18–35» ni kodda yig'sak, boshqa tilda so'z tartibi
  // va tinish belgisi o'zgartirib bo'lmas edi.
  "detail.ageRange": "Yosh: {min}–{max}",
  "detail.languageReqLine": "Til talabi: {text}",
  "detail.sourceNamed": "Manba: {name}",
  // Yurak tugmasi izohi. SONLI va SONSIZ shakl ALOHIDA: server sonni
  // chegaradan past bo'lsa yubormaydi (`like_count: null`) va bu «nol»
  // EMAS. Bitta kalitga `{n}` qo'yib, null o'rniga 0 yozsak, yashirilgan
  // son «0 ta layk» bo'lib ko'rinardi (types.ts: LikeResponse).
  "detail.likeHint": "E'longa layk bosish",
  "detail.likeHintCount": "E'longa layk bosish ({n} ta layk)",
  "detail.likedHint": "Sizga yoqdi",
  "detail.likedHintCount": "Sizga yoqdi ({n} kishi yoqtirdi)",

  // --- bosh ekran (qolgani) ---
  "home.all": "Barchasi",
  "home.search": "Qidiruv",
  "home.settings": "Sozlash",

  // --- saqlanganlar (qolgani) ---
  "saved.browse": "Imkoniyatlarni ko'rish",
  "saved.count#one": "{n} ta saqlangan",
  "saved.count#other": "{n} ta saqlangan",

  // --- qidiruv (qolgani) ---
  "search.clearFilters": "Filtrlarni tozalash",
  "search.filters": "Filtr",
  "search.submit": "Qidirish",
  "search.sort": "Saralash",
  "search.quickNoIelts": "IELTSsiz",
  "search.quickNoExperience": "Tajribasiz",
  "search.quickNoFee": "To'lovsiz",

  // --- onboarding (qolgani) ---
  "onboarding.next": "Davom etish",
  "onboarding.multiHint": "Bir nechtasini tanlash mumkin.",
  "onboarding.stageQuestion": "Hozir qaysi bosqichdasiz?",
  "onboarding.stageHint":
    "Bu eng muhim savol — tavsiyalar aynan shunga qarab tuziladi.",
  "onboarding.certQuestion": "IELTS yoki TOEFL sertifikatingiz bormi?",
  "onboarding.certHint":
    "Sertifikat bo'lmasa ham ko'p imkoniyat bor — biz ularni yuqoriga chiqaramiz.",
  "onboarding.ageQuestion": "Necha yoshdasiz?",
  "onboarding.ageHint":
    "Ko'p grantlarda yosh chegarasi bor — mos kelmaydiganlarini ko'rsatmaymiz.",
  "onboarding.birthYear": "Tug'ilgan yilingiz",
  "onboarding.fieldsQuestion": "Qaysi sohalar qiziq?",
  "onboarding.done": "Tayyor!",
  "onboarding.view": "Ko'rish",
  // BUTUN JUMLA, bo'lakma-bo'lak emas. Ekranda raqam qalin chiziladi,
  // lekin bo'lish MARKUP darajasida bo'ladi: lug'atda jumla butun
  // turadi, aks holda boshqa tilda so'z tartibi buzilardi
  // («Нашли 5 возможностей» — raqam boshida emas, o'rtasida).
  "onboarding.found#one": "Siz uchun {n} ta mos imkoniyat topdik",
  "onboarding.found#other": "Siz uchun {n} ta mos imkoniyat topdik",

  // --- taksonomiya yorliqlari ---
  // Qiymatlar SERVERDAN keladi, shuning uchun ular `tx()` orqali
  // dinamik olinadi. Lug'atda yo'q qiymat uchun qiymatning O'ZI
  // ko'rsatiladi — ichki kalit emas.

  // moliyalashtirish
  "funding.full": "To'liq grant",
  "funding.partial": "Qisman grant",
  "funding.travel_only": "Yo'l xarajati",
  "funding.stipend_only": "Stipendiya",
  "funding.free": "Bepul",
  "funding.unpaid": "To'lovsiz",

  // daraja
  "level.secondary": "Maktab",
  "level.bachelor": "Bakalavr",
  "level.master": "Magistratura",
  "level.phd": "PhD",
  "level.postdoc": "Post-doc",
  "level.any": "Har qanday daraja",
  "level.not_required": "Daraja shart emas",

  // format
  "format.onsite": "Joyida",
  "format.online": "Onlayn",
  "format.hybrid": "Aralash",

  // soha
  "field.it": "IT",
  "field.stem": "STEM",
  "field.medicine": "Tibbiyot",
  "field.business": "Biznes",
  "field.law": "Huquq",
  "field.arts": "San'at",
  "field.social": "Ijtimoiy",
  "field.education": "Ta'lim",
  "field.agriculture": "Qishloq xo'jaligi",
  "field.any": "Har qanday",

  // onboarding: hozirgi bosqich
  "status.maktab": "Maktab / litsey / kollej",
  "status.bakalavr_talaba": "Bakalavr talabasiman",
  "status.bakalavr_tugagan": "Bakalavrni tugatganman",
  "status.magistr_talaba": "Magistr talabasiman",
  "status.magistr_tugagan": "Magistrni tugatganman",
  "status.ishlayapti": "Ishlayapman, o'qimayapman",

  // onboarding: sertifikat
  "ielts.yes": "Ha, bor",
  "ielts.no": "Yo'q",
  "ielts.preparing": "Tayyorlanyapman",

  // kartochkadagi bayroqchalar
  "flag.no_ielts": "IELTSsiz",
  "flag.no_experience": "Tajriba shart emas",
  "flag.no_fee": "To'lovsiz",
  "flag.women_only": "Ayollar uchun",
  "flag.is_paid_position": "Oylik to'lanadi",

  // --- davlat nomlari ---
  // Ikki joyda kerak: ekranda «DE» o'rniga nom, va xarita so'rovini
  // tuzish («Max Planck Institute, Germaniya»). Ro'yxat to'liq emas —
  // bazada uchraydigan davlatlar; topilmasa kodning o'zi ko'rsatiladi.
  "country.AE": "BAA",
  "country.AT": "Avstriya",
  "country.AU": "Avstraliya",
  "country.AZ": "Ozarbayjon",
  "country.BE": "Belgiya",
  "country.BG": "Bolgariya",
  "country.BR": "Braziliya",
  "country.BY": "Belarus",
  "country.CA": "Kanada",
  "country.CH": "Shveytsariya",
  "country.CN": "Xitoy",
  "country.CZ": "Chexiya",
  "country.DE": "Germaniya",
  "country.DK": "Daniya",
  "country.EE": "Estoniya",
  "country.EG": "Misr",
  "country.ES": "Ispaniya",
  "country.FI": "Finlyandiya",
  "country.FR": "Fransiya",
  "country.GB": "Buyuk Britaniya",
  "country.GE": "Gruziya",
  "country.GR": "Gretsiya",
  "country.HU": "Vengriya",
  "country.ID": "Indoneziya",
  "country.IE": "Irlandiya",
  "country.IL": "Isroil",
  "country.IN": "Hindiston",
  "country.IT": "Italiya",
  "country.JP": "Yaponiya",
  "country.KG": "Qirg'iziston",
  "country.KR": "Janubiy Koreya",
  "country.KZ": "Qozog'iston",
  "country.LT": "Litva",
  "country.LV": "Latviya",
  "country.MY": "Malayziya",
  "country.NL": "Niderlandiya",
  "country.NO": "Norvegiya",
  "country.NZ": "Yangi Zelandiya",
  "country.PL": "Polsha",
  "country.PT": "Portugaliya",
  "country.QA": "Qatar",
  "country.RO": "Ruminiya",
  "country.RU": "Rossiya",
  "country.SA": "Saudiya Arabistoni",
  "country.SE": "Shvetsiya",
  "country.SG": "Singapur",
  "country.SK": "Slovakiya",
  "country.TH": "Tailand",
  "country.TJ": "Tojikiston",
  "country.TR": "Turkiya",
  "country.TW": "Tayvan",
  "country.UA": "Ukraina",
  "country.US": "AQSH",
  "country.UZ": "O'zbekiston",
  "country.VN": "Vetnam",
  "country.ZA": "Janubiy Afrika",

  // --- imkoniyat toifalari va tez filtrlar ---
  // Serverdan MATN ham keladi, lekin u faqat manba tilida. Klient
  // avval o'z lug'atiga qaraydi, server matni esa zaxira: bazaga
  // yangi toifa qo'shilib lug'atga yozilmasa, ekran bo'sh qolmaydi.
  // Toifa nomlari `labels.py` dagi bilan bir xil — biri kanal
  // rasmida, biri brauzerda, va ular bir faylni o'qiy olmaydi.
  "type.talim": "Ta'lim",
  "type.almashinuv": "Almashinuv",
  "type.tadqiqot": "Tadqiqot",
  "type.ish": "Ish va amaliyot",
  "type.tadbir": "Tadbirlar",
  "type.trening": "Trening",
  "type.tanlov": "Tanlovlar",
  "type.loyiha": "Loyiha granti",

  "quick.no_ielts": "IELTSsiz",
  "quick.full_funding": "To'liq grant",
  "quick.deadline_soon": "2 hafta ichida",

  // --- bayram tabriklari (holidays.ts) ---
  // Qaysi bayram qaysi tilda KO'RINISHI `holidays.ts` dagi `langs` da.
  // Matn esa HAR BIR tilda bo'lishi shart: bayram keyinroq boshqa tilga
  // ochilsa, tarjima tayyor turadi va zaxiraga tushib qolmaydi.
  "holiday.navruz.greeting": "Navro'z muborak!",
  "holiday.navruz.note": "Bahor va yangilanish ayyomi",
  "holiday.independence.greeting": "Mustaqillik kuni muborak!",
  "holiday.independence.note": "1-sentabr — O'zbekiston Mustaqilligi kuni",
  "holiday.new_year.greeting": "Yangi yilingiz muborak!",
  "holiday.new_year.note": "Yangi yilda yangi imkoniyatlar ochilsin",
  "holiday.ramadan.greeting": "Ramazon hayitingiz muborak!",
  "holiday.ramadan.note": "Ezgulik va saxovat kunlari",
  "holiday.qurbon.greeting": "Qurbon hayitingiz muborak!",
  "holiday.qurbon.note": "Ezgulik va saxovat kunlari",
} as const;

export type Key = keyof typeof uz;

// DIQQAT: `typeof uz` EMAS. `as const` qiymatlarni ham literal qilib
// qotiradi, ya'ni `Dict` "Yuklanmoqda…" degan AYNAN o'sha satrni talab
// qilardi va boshqa tildagi lug'at hech qachon `Dict` bo'la olmasdi.
// Bu yerda kalitlar qotadi, qiymatlar esa erkin — aynan kerakli narsa.
export type Dict = Record<Key, string>;
